<template>
  <service-view
    :pictures="pictures"
    :serviceTitle="serviceTitle"
    :aluminiumActive="'active'"
    :serviceDescription="serviceDescription"
  />
</template>
<script>
import ServiceView from "./ServiceView";
export default {
  name: "Aluminium",
  components: {
    ServiceView
  },
  data: () => ({
    pictures: [
      {
        name: "aluminium/IMG-20171103-WA0010.jpg",
        title: "Constructing a factory",
        location: "Zambia"
      },
      {
        name: "aluminium/IMG-20171103-WA0012.jpg",
        title: "Swimming pool construction",
        location: "Zambia"
      },
      {
        name: "aluminium/IMG-20171027-WA0010.jpg",
        title: "Constructing a factory",
        location: "Zambia"
      },
      {
        name: "aluminium/IMG-20171118-WA0045.jpg",
        title: "Swimming pool construction",
        location: "Zambia"
      },
      {
        name: "aluminium/IMG-20171027-WA0007.jpg",
        title: "Constructing a factory",
        location: "Zambia"
      },
      {
        name: "aluminium/IMG-20171009-WA0003.jpg",
        title: "Swimming pool construction",
        location: "Zambia"
      },
      {
        name: "aluminium/IMG-20171027-WA0003.jpg",
        title: "Constructing a factory",
        location: "Zambia"
      },
      {
        name: "aluminium/IMG-20171027-WA0004.jpg",
        title: "Swimming pool construction",
        location: "Zambia"
      },
      {
        name: "aluminium/IMG-20171027-WA0002.jpg",
        title: "Swimming pool construction",
        location: "Zambia"
      },
      {
        name: "aluminium/IMG-20171021-WA0005.jpg",
        title: "Swimming pool construction",
        location: "Zambia"
      }
    ],
    serviceTitle: "Aluminium",
    serviceDescription:
      "We offer aluminium fabrication & installation services with glass Railing Flooring Canopy Frameless Shower Enclosure Sliding Stacking Door System Seamless Glass System Skylight Aluminum Door and Window Mirror"
  })
};
</script>
